import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export interface TextRowProperties {
  label: string;
  value: string;
}

export const TextRow = ({ label, value }: TextRowProperties): ReactElement => {
  const { t } = useTranslation();

  return (
    <div className="final-screen__item">
      <div className="final-screen__text" data-test="left-column">
        {t(label)}:{' '}
      </div>
      <div className="final-screen__text final-screen__text--scrolled">
        <div className="final-screen__item-value" data-test="right-column">
          {value}
        </div>
      </div>
    </div>
  );
};
